import { render, staticRenderFns } from "./prepaidallocationform.vue?vue&type=template&id=1b1dd30a&"
import script from "./prepaidallocationform.vue?vue&type=script&lang=js&"
export * from "./prepaidallocationform.vue?vue&type=script&lang=js&"
import style0 from "./prepaidallocationform.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports